import { lpad, formatMinutesToHoursWithMinutes } from './../../../../utilities/calendarUtilities.js';

export const getFilterLabel = (label, selectedItems) => {
  const arrayNoSpaces = selectedItems.filter(item => item !== '');
  if (arrayNoSpaces.length === 0) return label;
  return `${label}: ${arrayNoSpaces.length}`;
};

export const filterItemsByUserInput = (search = null, items) => {
  if (!search) return items;
  search = search.toLowerCase();
  return items.filter(item => Object.values(item).join(' ').toLowerCase().match(search));
};

export const getFilterPropertyFromFilterId = (filterId) => {
  const filterProperties = {
    ACTIVITY_TYPES: 'activityTypes',
    ACTIVITY_ATTRIBUTES: 'activityAttributes',
    LAYOVERS: 'stationCodes',
    DATE_RANGE: 'activityDateRange',
    CREDIT_RANGE: 'creditRange',
    ACTIVITY_NAME: 'activityName',
    PAIRING_LENGTH:'pairingLengthRange',
    REPORT_TIME:'reportTimeRange',
    RELEASE_TIME:'releaseTimeRange'
  };
  return filterProperties[filterId] || filterId;
};

export const formatCreditValue = (value) => {
  if (!value) return '';
  value = parseInt(value, 10).toString();
  const paddedValue = lpad(value, 3, 0);
  let hours = paddedValue.substr(0, paddedValue.length - 2);
  let minutes = paddedValue.substr(-2);

  if (hours > 1000) hours = '1000';
  if (minutes > 59) minutes = '59';

  return `${hours}h${minutes}`;
};

export const formatStringToMinutes = (value) => {
  if (!value) return null;
  value = parseInt(value.split('h')[0] * 60, 10) + parseInt(value.split('h')[1], 10);
  return value;
};

export const rawCreditValue = formatedCreditInput => formatedCreditInput.split('h').join('');
